/**
 * @description 获取参数
 * @returns {string}
 */
export const addressBarQuery = (): string => location.search.substr(1)
